<template>
  <Modal v-model="visible" :mask-closable="false" title="赠送记录" :footer-hide="true" width="1280" class="my-modal">
    <div class="search-box ban3">
      <div class="input-item">
        <span class="label">链接对他人是否有效</span>
        <Select v-model="searchParams.effectiveStatus" placeholder="请选择" clearable>
          <Option value="null">全部</Option>
          <Option value="0">无效</Option>
          <Option value="1">有效</Option>
        </Select>
      </div>
      <div class="input-item">
        <span class="label">使用者手机号</span>
        <Input type="text" v-model="searchParams.holderMobile" placeholder="请输入" clearable />
      </div>
      <div class="btn-item">
        <Button type="primary" @click="searchAjax()">查询</Button>
        <Button class="addbtn" type="primary" ghost @click="exportToExcel">导出</Button>
      </div>
    </div>
    <div class="table-box">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="holderMobile">
          <span class="text" v-if="row.eyeShow">{{ row.mobile }}</span>
          <span class="text" v-else>{{ row.holderMobile }}</span>
          <i class="iconfont iconxianshi eye-icon" v-if="row.eyeShow && row.holderMobile" @click="openEye(row)"></i>
          <i class="iconfont iconyincang eye-icon" v-else-if="!row.eyeShow && row.holderMobile" @click="openEye(row)"></i>
        </template>
      </Table>
      <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center" v-if="tableData.length" />
    </div>
  </Modal>
</template>
<script>
import { pageTool, common } from '@/api/mixins';
export default {
  mixins: [pageTool, common],
  data: () => ({
    loading: false,
    visible: false,
    searchParams: {},
    columns: [
      {
        title: '序号',
        type: 'index',
        align: 'center',
        width: 80
      },
      {
        title: '微信昵称',
        key: 'nickname',
        width: 120,
        align: 'center'
      },
      {
        title: '投保人',
        key: 'holderName',
        width: 120,
        align: 'center'
      },
      {
        title: '链接对他人是否有效',
        key: 'effectiveStatus',
        width: 120,
        align: 'center',
        render(h, params) {
          const value = params.row.effectiveStatus == 1 ? '有效' : '无效';
          return <div>{value}</div>;
        }
      },
      {
        title: '订单号',
        key: 'orderNo',
        align: 'center'
      },
      {
        title: '保单号',
        key: 'policyNo',
        align: 'center'
      },

      {
        title: '手机号',
        slot: 'holderMobile',
        width: 160,
        align: 'center'
      },
      {
        title: '创建时间',
        key: 'createTime',
        align: 'center',
        width: 160,
        render(h, params) {
          if (params.row.createTime) {
            const value = params.row.createTime.substr(0, 16);
            return <div>{value}</div>;
          }
        }
      }
    ]
  }),
  created() {},
  methods: {
    open(data) {
      this.visible = true;
      this.searchParams = {
        salemanJoinId: data.id,
        policyNo: '',
        orderNo: '',
        holderMobile: '',
        date: [],
        effectiveStatus: 'null'
      };
      this.initListAjax('/buz/giveawayProduct/queryShareList');
    },
    // 转化参数
    setListParams(params) {
      if (params.effectiveStatus == 'null') {
        delete params.effectiveStatus;
      }
      if (params.date && params.date[0]) {
        params.createTimeStart = params.date[0];
        params.createTimeEnd = params.date[1];
      }
      delete params.date;
    },
    // 解密
    openEye(row) {
      if (!row.eyeShow) {
        this.descrypt(
          {
            query: row.orderNo,
            otherInfo: { type: 1 },
            operationFunction: 14,
            operationType: 2
          },
          row,
          'mobile'
        ).then(() => {
          this.$set(row, 'eyeShow', true);
        });
      } else {
        this.$set(row, 'eyeShow', false);
      }
    },
    exportToExcel() {
      const params = JSON.parse(JSON.stringify(this.searchParams));
      this.setListParams(params);
      this.$units.downloadFile('/buz/giveawayProduct/exportShareList', params, 'POST');
    }
  }
};
</script>
<style lang='scss' scoped>
</style>